import * as React from 'react';
import { Tag } from '../../internal/components/Tag';
import * as styles from './styles.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var Tags = function Tags(props) {
  var _onClose = props.onClose,
    options = props.options,
    size = props.size;
  return /*#__PURE__*/_jsx("div", {
    className: styles['tags'],
    children: /*#__PURE__*/_jsx("div", {
      className: styles['tags_wrapper'],
      children: options.map(function (option) {
        return /*#__PURE__*/_jsx("div", {
          className: styles['tags_item'],
          children: /*#__PURE__*/_jsx(Tag, {
            onClose: function onClose() {
              return _onClose(option);
            },
            size: size,
            children: option.label
          })
        }, option.value);
      })
    })
  });
};
Tags.displayName = 'Tags';